import {axiosPrivate} from "../axios-config/axiosPrivate";
import {standardRequestConfig} from "../axios-config/requestConfig";
import {BACKEND} from "../config/backend";
import {wrapUrlComponents} from "../store/utils/urlHelper";

export const getKundenListData = ({kundenListParameter}) => {
    return axiosPrivate.get(`${BACKEND}/api/v1/kunden/list`, {
        ...standardRequestConfig
        , params: kundenListParameter
    })
}

export const getKundenBySearchStringAndArtist = ({searchString, selectedArtistID}) => {
    const searchParameters = wrapUrlComponents({searchstring: searchString, artistid: selectedArtistID})
    return axiosPrivate.get(`${BACKEND}/api/v1/kunden?${searchParameters}`, {
        ...standardRequestConfig
    })
}

export const getKundenByKundIdList = ({kundIdList}) => {
    const kundenids = kundIdList.join(",")
    const searchParameters = wrapUrlComponents({kundenids})
    return axiosPrivate.get(`${BACKEND}/api/v1/kunden?${searchParameters}`, {
        ...standardRequestConfig
    })
}

export const getKundenTermine = ({kundId}) => {
    return axiosPrivate.get(`${BACKEND}/api/v1/kunden/${kundId}/termine`, {
        ...standardRequestConfig
    })
}

export const getKundenProjekte = ({kundId}) => {
    return axiosPrivate.get(`${BACKEND}/api/v1/kunden/${kundId}/projekte`, {
        ...standardRequestConfig
    })
}

export const getKundenFormularstatusOfTermin = ({terminId}) => {
    return axiosPrivate.get(`${BACKEND}/api/v1/kunden/formularstatus`, {
        ...standardRequestConfig
        , params: {terminid: terminId}
    })
}

export const getKundenData = ({kundId}) => {
    return axiosPrivate.get(`${BACKEND}/api/v1/kunden/${kundId}`, {
        ...standardRequestConfig
    })
}

export const getOnlyKundeBase = ({kundId}) => {
    return axiosPrivate.get(`${BACKEND}/api/v1/kunden/${kundId}?onlybase=true`, {
        ...standardRequestConfig
    })
}

export const getKundenDoubletten = ({Vorname, Nachname, Email, Mobil}) => {
    return axiosPrivate.get(`${BACKEND}/api/v1/kunden/doubletten`, {
        ...standardRequestConfig
        , params: {
            Vorname, Nachname, Email, Mobil
        }
    })
}

export const getDoubletten = () => {
    return axiosPrivate.get(`${BACKEND}/api/v1/kunden/doubletten`, {
        ...standardRequestConfig
    })
}

export const mergeDoubletten = ({mergeData}) => {
    return axiosPrivate.post(`${BACKEND}/api/v1/kunden/doubletten/merge`, mergeData, {
        ...standardRequestConfig
    })
}

export const updateKunde = ({kunde}) => {
    return axiosPrivate.put(`${BACKEND}/api/v1/kunden/${kunde.KundID}`, kunde, {
        ...standardRequestConfig
    })
}

export const insertKunde = ({kunde}) => {
    return axiosPrivate.post(`${BACKEND}/api/v1/kunden/`, kunde, {
        ...standardRequestConfig
    })
}

export const importKunden = ({kunden}) => {
    return axiosPrivate.post(`${BACKEND}/api/v1/kunden/import`, kunden, {
        ...standardRequestConfig
    })
}

export const sendFileLink = ({kundId, fileId}) => {
    return axiosPrivate.post(`${BACKEND}/api/v1/kunden/messages/filelink`, {kundId, fileId}, {
        ...standardRequestConfig
    })
}

export const deleteKunde = ({kundId}) => {
    return axiosPrivate.delete(`${BACKEND}/api/v1/kunden/${kundId}`, {
        ...standardRequestConfig
    })
}

export const getDblExclusionList = ({datVon, datBis}) => {
    return axiosPrivate.get(`${BACKEND}/api/v1/kunden/doubletexclusions`, {
        ...standardRequestConfig
        , params: {datVon, datBis}
    })
}

export const deleteDblExclusion = ({kdExDblId}) => {
    return axiosPrivate.delete(`${BACKEND}/api/v1/kunden/doubletexclusions/${kdExDblId}`, {
        ...standardRequestConfig
    })
}

export const addDblExclusions = ({exclusionData}) => {
    return axiosPrivate.post(`${BACKEND}/api/v1/kunden/doubletexclusions`, exclusionData, {
        ...standardRequestConfig
    })
}

export const analyzeDoublettenWizard = async () => {
    const response = await axiosPrivate.post(`${BACKEND}/api/v1/kunden/doubletten/wizard/analyze`);
    return response.data;
}

export const executeDoublettenWizard = async ({analysisId}) => {
    const response = await axiosPrivate.post(`${BACKEND}/api/v1/kunden/doubletten/wizard/execute`, {analysisId});
    return response.data;
}